import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { AppBar, Avatar, Typography, Divider, Grid, List,
	ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText,
	CircularProgress, TextField, Toolbar, Chip
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import Actions from 'components/Actions';
import { Status } from 'context/RestAPI';
import styles from './styles';


function SearchOverview({ classes, applicationObjects, objectsActions, filter, presetFilter }) {
	const [preset, setPreset] = useState(presetFilter);
	const [filterStr, setFilterStr] = useState("");

	const onSearchFieldChange = () => () => {
		setFilterStr(document.getElementById("search_field").value);
	}

	const filterItems = (applicationObject) => {
		if (preset) {
			return filter(applicationObject, filterStr) && filter(applicationObject, preset);	
		}
		return filter(applicationObject, filterStr);
	} 

	const removePreset = () => {
		setPreset(null);
	}

	let filteredItems = applicationObjects.filter(filterItems);

    return (
        <>
		<AppBar className={classes.searchBar} position="static" color="default" elevation={0}>
			<Toolbar>
				<Grid container spacing={0} alignItems="center">
					<Grid item>
						<SearchIcon className={classes.block} color="inherit" />
					</Grid>
					<Grid item xs>
						<TextField
							error
							id="search_field"
							fullWidth
							placeholder={applicationObjects.searchbarPlaceholder}
							InputProps={{
								disableUnderline: true,
								className: classes.searchInput,
							}}
							onChange={onSearchFieldChange()}
						/>
					</Grid>
				</Grid>
				{(preset) ? (
					<Chip
						label={preset}
						size="small"
						onDelete={removePreset}
						className={classes.chip}
					/>
				) : null }
				
			</Toolbar>
		</AppBar>

		{((applicationObjects.status == Status.Success) && (filteredItems.length > 0)) ? (
			<List>
				{filteredItems.map((applicationObject, index, subList) => (
					<>
					<ListItem key={`search_list_item_${applicationObject.id}`}>
						<ListItemAvatar>
							<Avatar>
								{applicationObject.icon}
							</Avatar>
						</ListItemAvatar>
						<ListItemText
							primary={applicationObject.getTitle()}
							secondary={applicationObject.getSubtitle()}
						/>
						<ListItemSecondaryAction className={classes.root}>
							<Actions actions={objectsActions} item={applicationObject} />
						</ListItemSecondaryAction>
					</ListItem>
					{(index != subList.length - 1) ? <Divider key={`search_list_divider_${applicationObject.id}`} light variant="inset" component="li" /> : null }
					</>
				))}
			</List>	
		) : null }
		{((applicationObjects.status == Status.Success) && (filteredItems.length == 0)) ? (
			<Typography className={classes.contentWrapper} color="textSecondary" align="center">
				No {applicationObjects.objectName} found.
			</Typography>
		) : null }

		{(applicationObjects.status == Status.Loading) ? (
			<div className={classes.contentWrapper}>
				<div className={classes.progressbar}>
					<CircularProgress />
				</div>
			</div>
		) : null }

		{(applicationObjects.status == Status.Init) ? (
			<Typography className={classes.contentWrapper} color="textSecondary" align="center">
				Authentication, please wait ...
			</Typography>
		) : null }

		{(applicationObjects.status == Status.Unauthorized) ? (
			<Typography className={classes.contentWrapper} color="textSecondary" align="center">
				Authentication failed! Please refresh your session.
			</Typography>
		) : null }

		{(applicationObjects.status == Status.Empty) ? (
			<Typography className={classes.contentWrapper} color="textSecondary" align="center">
				No {applicationObjects.objectName} found.
			</Typography>
		) : null }

		{(applicationObjects.status == Status.Error) ? (
			<Typography className={classes.contentWrapper} color="textSecondary" align="center">
				Wupps, an error occured! Please try again later.
			</Typography>
		) : null }
		</>
    );
}

SearchOverview.propTypes = {
	classes: PropTypes.object.isRequired,
	applicationObjects: PropTypes.object.isRequired, 
	objectsActions: PropTypes.array.isRequired,
	filter: PropTypes.func.isRequired,
	presetFilter: PropTypes.string
}

export default withStyles(styles)(SearchOverview);